import { keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { SPACING, COLORS3, MEDIA_QUERY } from '../../styles/emotion';

const scroll = keyframes`
  from {
    transform: translateX(0);
  }
  to {
    transform: translateX(calc(-100% - var(--gap)))
  }
`;

export const LogosWrapper = styled.div`
  max-width: 1920px;
  background-color: ${COLORS3.WHITE_100};
  border-bottom: 1px solid ${COLORS3.BLACK_030};

  align-items: center;
  height: 122px;
  --gap: 1rem;
  position: relative;
  display: flex;
  overflow: hidden;
  user-select: none;
  gap: var(--gap);

  ${MEDIA_QUERY.TABLET} {
    height: 78px;
  }
  ${MEDIA_QUERY.MOBILE} {
    height: 63px;
  }
`;

export const AnimationWrapper = styled.div<{ animationSpeed: number }>`
  flex-shrink: 0;
  display: flex;
  justify-content: space-around;
  gap: var(--gap);
  min-width: 100%;
  align-items: center;
  animation: ${scroll} ${(props) => props.animationSpeed}s linear infinite;
`;

export const StyledImage = styled.img`
  max-height: 84px; // 164px - 80px of padding
  margin-right: ${SPACING.XXL};

  ${MEDIA_QUERY.DESKTOP} {
    max-width: 200px;
  }

  ${MEDIA_QUERY.TABLET} {
    height: 38px; // 78px - 40px of padding
  }
  ${MEDIA_QUERY.MOBILE} {
    height: 23px; // 63px - 40px of padding

    margin-right: ${SPACING.XL};
  }
`;
